<template>
  <div class="wholeContext">
  <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
  <div class="appContext withWidget">
    <tracking-progress :transDataSet="transDate"></tracking-progress>
    <div class="join container">
      <div class="joinTitle">
        <h3>본인인증</h3>
        <p class="warn">필수 동의 사항입니다.</p>
      </div>
      <div class="joinContext">
<!--        <div class="wholeCheck article" @click="authorizeWholeCheck">-->
<!--          <p>전체동의</p><span class="imgWrap"><img :src="authorizeChecked.wholeCheck ? buttonCheckUrl.checkOn : buttonCheckUrl.checkUn"></span>-->
<!--        </div>-->
        <div class="article term" v-if="this.getTerms">
          <p>서비스 이용약관</p>
          <span class="imgWrap">
            <img :src="require(`@/assets/images/${agreeBtn.checkOn}`)">
          </span>
        </div>
        <div class="article term" v-else @click="serviceAgree">
          <p>서비스 이용약관</p>
          <span class="imgWrap rotate">
            <img :src="require(`@/assets/images/${agreeBtn.checkUn}`)">
          </span>
        </div>
        <div class="article term" v-if="this.getPrivacy">
          <p>개인정보 수집이용동의</p>
          <span class="imgWrap">
            <img :src="require(`@/assets/images/${agreeBtn.checkOn}`)">
          </span>
        </div>
        <div class="article term" v-else @click="individualAgree">
          <p>개인정보 수집이용동의</p>
          <span class="imgWrap rotate">
            <img :src="require(`@/assets/images/${agreeBtn.checkUn}`)">
          </span>
        </div>
      </div>
    </div>
    <!-- 안심본인인증 서비스 팝업 호출 form -->
    <form method="post" name="form_chk">
      <!-- 요청모드 (필수 데이터) -->
      <input type="hidden" name="m" value="checkplusSerivce">
      <!-- 업체정보 암호화 데이터 -->
      <input type="hidden" name="EncodeData" :value="this.getIdentity">
      <div class="btnWrap" :class="{visible : agreeFlag}">
        <button type="button" class="callTerms" @click="nextFormData()">다음</button>
      </div>
    </form>
  </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '../../components/AppHeader'
import AppSidebar from '../../components/AppSidebar'
import TrackingProgress from '../../components/TrackingProgress'
import AddPopup from '@/components/AddPopup'
import { mapMutations, mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '모든 항목에 동의해주세요.',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close',
        bigModal: false
      },
      transDate: {
        headerName: '회원가입',
        progressNum: '25%',
        chapterNum: 1,
        prevUrl: '/ChoiceType'
      },
      authorizeChecked: {
        wholeCheck: '',
        serviceCheck: '',
        individualCheck: ''
      },
      buttonCheckUrl: {
        checkOn: 'images/ck_on.png',
        checkUn: 'images/ck_un.png'
      },
      agreeBtn: {
        checkOn: 'ck_on.svg',
        checkUn: 'dropdown.svg'
      },
      agreeFlag: false,
      setCount: false
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters([
      'getPrivacy',
      'getTerms',
      'getIdentity'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('identity', [
      'SET_URL'
    ]),
    authorizeWholeCheck () {
      if (!this.authorizeChecked.wholeCheck) {
        this.authorizeChecked.serviceCheck = true
        this.authorizeChecked.individualCheck = true
      } else {
        this.authorizeChecked.serviceCheck = false
        this.authorizeChecked.individualCheck = false
      }
      this.authorizeChecked.wholeCheck = !this.authorizeChecked.wholeCheck
    },
    serviceAgree () {
      this.$router.push('/joinTerms')
    },
    individualAgree () {
      this.$router.push('/joinPrivacy')
    },
    authorizeServiceCheck () {
      if (this.authorizeChecked.individualCheck && !this.authorizeChecked.serviceCheck) {
        this.authorizeChecked.wholeCheck = true
      } else {
        this.authorizeChecked.wholeCheck = false
      }
      this.authorizeChecked.serviceCheck = !this.authorizeChecked.serviceCheck
    },
    authorizeIndividualCheck () {
      if (this.authorizeChecked.serviceCheck && !this.authorizeChecked.individualCheck) {
        this.authorizeChecked.wholeCheck = true
      } else {
        this.authorizeChecked.wholeCheck = false
      }
      this.authorizeChecked.individualCheck = !this.authorizeChecked.individualCheck
    },
    async prePreURL () {
      console.log('URL 준비진입')
      const url = document.location.href
      console.log('url: ', url)
      this.SET_URL(url)
      localStorage.setItem('url', url)
    },
    async prePareForm () {
      if (!this.getTerms) {
        this.SET_POPUP(true)
        this.popupSet.content = '서비스 이용약관에 동의해주세요.'
        return false
      }
      if (!this.getPrivacy) {
        this.SET_POPUP(true)
        this.popupSet.content = '개인정보 수집 이용에 동의해주세요.'
        return false
      } else {
        this.fnPopup()
      }
    },
    async nextFormData () {
      await this.prePreURL()
      await this.prePareForm()
    },
    submitForm () {
      this.fnPopup()
    },
    fnPopup () {
      window.name = 'Parent_window'
      // window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no')
      document.form_chk.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb'
      document.form_chk.target = 'Parent_window'
      document.form_chk.submit()
      self.close()
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/ChoiceType')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    if (this.getPrivacy && this.getTerms) {
      this.agreeFlag = true
    } else {
      this.agreeFlag = false
    }
    console.log('this.getIdentity: ', this.getIdentity)
    if (this.getIdentity === '') {
      this.SET_POPUP(true)
      this.popupSet.count = 'another'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/ChoiceType'
      this.popupSet.content = '처음부터 다시 진행해주세요.'
      this.popupSet.nextLink = '/ChoiceType'
    }
    // console.log('getEncCode: ', this.getEncCode)
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
